// extracted by mini-css-extract-plugin
export default {"content":"AddVip_content__KZXtK","header":"AddVip_header__JJi8W"};